import { useCallback, useEffect, useState } from "react"

import { useAgentPlatform } from "@/pages/DeploymentsPage/application/useAgentPlatform"
import { DEFAULT_COPILOT_STUDIO_SETTINGS } from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"

import type {
  CopilotStudioConnection,
  CopilotStudioPreInstall
} from "@/api/useDeployments.types"

// The tenant's threat detection values, the same for every connection, and
// whether it is offered: read once a connection is open
export const useThreatDetection = (
  connection: CopilotStudioConnection | undefined
) => {
  const platform = useAgentPlatform("copilot-studio")
  const [preInstall, setPreInstall] = useState<CopilotStudioPreInstall>()
  const { isPreInstallIdle } = platform

  const load = useCallback(
    async () =>
      setPreInstall(
        await platform.preInstall({
          ...DEFAULT_COPILOT_STUDIO_SETTINGS,
          ...connection?.settings
        })
      ),
    [platform, connection]
  )

  useEffect(() => {
    if (connection && !preInstall && isPreInstallIdle) load()
  }, [connection, preInstall, isPreInstallIdle, load])

  return {
    preInstall,
    isLoading: platform.isPreInstalling,
    error: platform.error,
    onRetry: load
  }
}
